export const FAVORITE_CUISINES = [
  'Italian',
  'Asian',
  'Mexican',
  'Mediterranean',
  'American',
  'Indian',
  'Middle Eastern',
  'South American',
  'Caribbean',
];

export const DIETARY_RESTRICTIONS = [
  'Vegetarian',
  'Vegan',
  'Gluten-Free',
  'Dairy-Free',
  'Pescatarian',
  'Paleo',
];

export const ALlERGIES = ['Dairy', 'Nut', 'Seafood', 'Gluten', 'Soy', 'Egg'];

export const ADVENTUROUS = ['Mild', 'Medium', 'Spicy'];

export const MEAL_PREPARING_TIME = ['15-30 mins', '30-45 mins', '45 mins & above'];

export const COMFORT_LEVEL = ['Beginner', 'Intermediate', 'Advanced'];
